import React, { useContext } from "react";
import "./Form.scss";
import { AppContext } from "../../stores/application.store";
import { ValidateForm } from "../../services/validator.js";
import { sendLead } from "../../services/api";
import { ga_push } from "../../services/sharing";
const Form = () => {
  const { formValue, setFormValue, setPopupValue, setSelectPopupVisible } = useContext(AppContext);

  

  const ButtonSubmit = () => {
    if (!ValidateForm(formValue)) {
      return;
    } else {
      sendLead(formValue).then((didSucceed) => {
        if (!didSucceed) {
          setPopupValue({
            isShowing: true,
            text: "פרטייך כבר במערכת",
            secondaryText: "",
          });

          ga_push("Form_Events", "Forms", "Form Submission", "Fail");
        } else {
          setPopupValue({
            isShowing: true,
            text: "פרטייך הוזנו במערכת",
            secondaryText: "",
            showLink: true
          });

          ga_push("Form_Events", "Forms", "Form Submission", "Success");
        }
      }).then(() => {
        setFormValue({
          fullName: "",
          phone: "",
          email: "",
          bussinessName: "",
          activity: "",
          bussinessId: "",
          bussinessLocation: "",
          poalimClient: null,
          description: "",
          digitalChoice: "",
          privacyAgree: false,
        })
      });
    }
  };

  return (
    <div className="form-wrapper">
      <div className="form">
        <input
          type="text"
          value={formValue.fullName}
          onChange={(e) =>
            setFormValue({ ...formValue, fullName: e.target.value })
          }
          placeholder="שם מלא"
        ></input>

        <input
          type="text"
          value={formValue.phone}
          onChange={(e) =>
            setFormValue({ ...formValue, phone: e.target.value })
          }
          placeholder="טלפון"
        ></input>

        <input
          type="text"
          value={formValue.email}
          onChange={(e) =>
            setFormValue({ ...formValue, email: e.target.value })
          }
          placeholder='דוא"ל'
        ></input>

        <input
          type="text"
          value={formValue.bussinessName}
          onChange={(e) =>
            setFormValue({ ...formValue, bussinessName: e.target.value })
          }
          placeholder="שם העסק"
        ></input>

        <input
          type="text"
          value={formValue.activity}
          onChange={(e) =>
            setFormValue({ ...formValue, activity: e.target.value })
          }
          placeholder="תחום פעילות"
        ></input>

        <input
          type="text"
          value={formValue.bussinessId}
          onChange={(e) =>
            setFormValue({ ...formValue, bussinessId: e.target.value })
          }
          placeholder="ח.פ"
        ></input>

        <input
          type="text"
          value={formValue.bussinessLocation}
          onChange={(e) =>
            setFormValue({ ...formValue, bussinessLocation: e.target.value })
          }
          placeholder="מיקום בית העסק"
        ></input>

        <div className="client-radio">
          <h6>לקוח בנק הפועלים</h6>

          <div className="inputs">
            <input
              id="is-client"
              type="radio"
              name="client-choice"
              value={true}
              checked={formValue.poalimClient == true}
              onChange={(e) =>
                setFormValue({ ...formValue, poalimClient: e.target.checked })
              }
            ></input>
            <label htmlFor="is-client">כן</label>
            <input
              id="isnt-client"
              type="radio"
              name="client-choice"
              value={false}
              checked={formValue.poalimClient == false}
              onChange={(e) =>
                setFormValue({ ...formValue, poalimClient: !e.target.checked })
              }
            ></input>
            <label htmlFor="isnt-client">לא</label>
          </div>
        </div>

        <textarea
          placeholder="האם העסק פעיל כיום בזירה הדיגיטלית? באילו כלים?"
          value={formValue.description}
          onChange={(e) =>
            setFormValue({ ...formValue, description: e.target.value })
          }
        ></textarea>
        <div className="select-wrapper">
          <select
            defaultValue={0}
            onChange={(e) =>
              setFormValue({
                ...formValue,
                digitalChoice: e.target.selectedOptions[0].text,
              })
            }
          >
            <option value={0} disabled selected={formValue.digitalChoice == 0}>
              איפה היית רוצה להסתייע ולקבל חיזוק דיגיטלית?
            </option>
            <option>הקמת אתר/הקמת חנות אונליין</option>
            <option>
              כלי שיווק דיגיטלי לגיוס לקוחות חדשים (גוגל / פייסבוק / אינסטגרם /
              אאוטבריין וטאבולה)
            </option>
            <option>
              דיוור שיווקי (הקמת דיוור במערכת דיוור / הכנת תוכן כתוב וויזואלי
              לדיוור שיווקי)
            </option>
            <option>
              יצירת חומרים שיווקיים (עיצוב בקנבה / כתיבה שיווקית / בניית עמוד
              נחיתה)
            </option>
            <option>
              הגדלת נוכחות דיגיטלית ושימוש בפלטפורמות הקידום השונות (איזי /
              פייבר / גוגל מיי ביזנס / גט דליברי)
            </option>
            <option>
              רשתות חברתיות (ניהול עמוד שיווק בפייסבוק, אינסטגרם / יצירת קהילה
              וכד')
            </option>
          </select>
        </div>
        <div className="mobile-select-wrapper">
          <div className="mobile-select" onClick={() => setSelectPopupVisible(true)}>
            <h3 className="mobile-select-text">
              {formValue.digitalChoice ? formValue.digitalChoice.substring(0,40)+ (formValue.digitalChoice.length > 40 ? "..." : "") : "איפה היית רוצה להסתייע ולקבל חיזוק דיגיטלית?"}
            </h3>
          </div>
        </div>
        <div className="ending">
          {/* <div className="checkbox-wrapper first">
            <input
              type="checkbox"
              id="tos"
              onChange={(e) =>
                setFormValue({ ...formValue, tosAgree: e.target.checked })
              }
            ></input>
            <label htmlFor="tos">
              הרשמה לתחרות והשתתפות בה יהיו כפופים לתקנון
            </label>
          </div> */}
          <div className="checkbox-wrapper first">
            <input
              type="checkbox"
              id="privacy"
              checked={formValue.privacyAgree}
              onChange={(e) =>
                setFormValue({ ...formValue, privacyAgree: e.target.checked })
              }
            ></input>
            <label htmlFor="privacy">
            קראתי, הבנתי ומסכים ל
            <a href="https://z.ynet.co.il/mShort/generics/Leads/TOS/81/" target="_blank">תקנון</a>
            , ל
            <a href="https://z.ynet.co.il/short/content/2018/privacypolicy/policy.html" target="_blank">מדיניות הפרטיות</a>
             ונותן הסכמתי לקבלת דברי פרסום מאתר ynet.
            </label>
          </div>
          <button className="send-button" onClick={ButtonSubmit}>
            שלח
          </button>
        </div>
      </div>
    </div>
  );
};

export default Form;
